import { DATE_FORMATS, formatDateToUI } from '@dealstack/shared/lib/format/dates/date';
import { KycEventLogAction, KycEventLogEntity } from '@dealstack/shared/lib/generated';

export interface DecisionAudit {
	auditedBy?: string;
	timestamp?: string;
}

const formatActor = (event: KycEventLogEntity): string | undefined => {
	const user = event.userAction.userSession?.user;
	if (user) {
		return `${user.firstName} ${user.lastName}`;
	}
	return event.userAction.publicSigner?.fullName ?? undefined;
};

const formatWhen = (event: KycEventLogEntity) =>
	formatDateToUI(new Date(event.createdAt), DATE_FORMATS.DATE_TIME_ALT);

export const getDecisionAudit = (events: KycEventLogEntity[] | undefined): DecisionAudit => {
	if (!events?.length) {
		return {};
	}
	const reviewed = events
		.filter((event) => event.action === KycEventLogAction.REVIEWED)
		.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
	const latest = reviewed[0];
	if (!latest) {
		return {};
	}
	return {
		auditedBy: formatActor(latest),
		timestamp: formatWhen(latest),
	};
};
